module.exports = __webpack_public_path__ + "img/cleaner_arrived.01a5f9e3.svg";